import React from "react"
import Typography from "aldoo-ra/Typography"
import CMSRender from "aldoo-ra/CMS/cms-render"
import parse from "html-react-parser"
import Localization from "aldoo-ra/Localization"

/**
 * The document's body, when the text is a whole HTML document (the policies
 * are pasted in as one): a page cannot hold another <html>, and the browser
 * drops those tags from the server's markup — the page then no longer
 * matched what React rendered, and was thrown away and rendered again.
 */
const bodyOf = (html) => {
  if (typeof html !== "string") return ""
  const body = html.match(/<body[^>]*>([\s\S]*?)<\/body>/i)
  if (body) return body[1]
  return html.replace(/<!DOCTYPE[^>]*>/gi, "").replace(/<\/?(html|head|body)[^>]*>/gi, "").replace(/<(meta|title|link)[^>]*>(<\/title>)?/gi, "")
}

export default function ServicePage({ id }) {
  return (
    <div className="w-full pt-10 pb-20">

      {/* Title + Body */}
      <CMSRender
        contentType="ServiceText"
        match={{ "content.id": id }}
        renderItem={(data) => {
          return (
            <div>
              <div className="relative flex flex-col items-center w-full max-w-[700px] md:max-w-[900px] xl:max-w-w1_xl px-4 xl:px-20 mx-auto z-50">
                <Typography
                  variant="h1"
                  className="mb-8"
                >
                  {data.title}
                </Typography>

                <div className="service_page w-full">
                  {parse(bodyOf(data.text))}
                </div>
              </div>
            </div>
          );
        }}
      />
    </div>
  );
}
